import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import Label from 'src/components/Label';
import DataTable, { DataTableColumn } from 'src/components/table/DataTable';
import api from 'src/ccm/services/api';
import { CreatedUpdated } from '../common';
import GoalsContextMenu from './GoalsContextMenu';

const columns: DataTableColumn[] = [
  {
    header: 'Goal',
    field: 'name',
  },
  {
    header: 'Alias Name',
    field: 'alias',
  },
  {
    header: 'Status',
    field: 'status',
    render(value) {
      return (
        <Label color={value === 'active' ? 'success' : 'info'}>
          {value === 'active' ? 'Active' : 'Inactive'}
        </Label>
      );
    },
  },
  {
    header: 'Created',
    field: '$',
    render(value) {
      return <CreatedUpdated by={value.createdBy} date={value.createdOn} />;
    },
  },
  {
    header: 'Updated',
    field: '$',
    render(value) {
      return <CreatedUpdated by={value.updatedBy} date={value.updatedOn} />;
    },
  },
];

export default function GoalsTable() {
  const { data: goals = [], refetch } = useQuery(
    ['goals'],
    async () =>
      (await api.carePlan.findGoals({
        status: '',
      })) as any[]
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <div>
      <DataTable
        columns={columns}
        data={goals}
        selectable
        rowContextMenu={(item: any) => (
          <GoalsContextMenu
            item={item}
            onDelete={() => {
              refetch();
            }}
          />
        )}
      />
    </div>
  );
}
